import PropTypes from "prop-types";
import React from "react";

const MenuIconAI = ({ label = "Menu", color = "#28a745", size = "small" }) => {
  const sizes = {
    small: "0.8rem",
    medium: "1rem",
    large: "1.2rem",
  };

  return (
    <div className="menu-icon" style={{ backgroundColor: color }}>
      <span className="menu-icon-label" style={{ fontSize: sizes[size] }}>
        {label}
      </span>
      <style>
        {`
          .menu-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 5px 10px;
          border-radius: 15px;
          color: white;
          font-weight: bold;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .menu-icon:hover {
          transform: scale(1.1);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
        }

        .menu-icon-label {
          text-transform: uppercase;
          font-family: Arial, sans-serif;
        }
      `}
      </style>
    </div>
  );
};

MenuIconAI.propTypes = {
  label: PropTypes.string, // Text displayed on the icon
  color: PropTypes.string, // Background color of the icon
  size: PropTypes.oneOf(["small", "medium", "large"]), // Font size of the label
};

export default MenuIconAI;
